// Indice di ricerca globale del sito Confcommercio Roma
// Aggrega contenuti da tutti i data file in un array normalizzato usato da GlobalSearch.
import { SERVIZI_CATEGORIE, ASSOCIAZIONI as ASSOC_HOME } from "@/data/siteData";
import { ASSOCIAZIONI as ASSOC_LIST } from "@/data/associazioniList";
import { CORSI } from "@/data/corsiData";
import { NEWS_FULL } from "@/data/newsData";
import { EVENTI_FULL } from "@/data/eventiData";
import { PARTNER_DETTAGLI } from "@/data/partnerConvenzioniData";
import { IMPEGNO_POLITICO_TEMI } from "@/data/impegnoPoliticoData";

// Pagine "statiche" principali sempre indicizzate
const STATIC_PAGES = [
  { title: "Home", subtitle: "Torna alla home page", path: "/", keywords: "home confcommercio roma" },
  { title: "Chi siamo", subtitle: "Storia, organismi e struttura di Confcommercio Roma", path: "/chi-siamo", keywords: "chi siamo storia valori" },
  { title: "Storia e valori", subtitle: "La storia di Confcommercio Roma dal 1944", path: "/chi-siamo/storia-e-valori", keywords: "storia valori 1944 tradizione" },
  { title: "Il Nostro Impegno", subtitle: "6 temi programmatici e proposte politiche", path: "/chi-siamo/impegno-politico", keywords: "impegno politico manifesto proposte roma" },
  { title: "Organismi", subtitle: "Presidente, Giunta, Consiglio, Assemblea", path: "/chi-siamo/organismi", keywords: "presidente organi direttivi consiglio" },
  { title: "Statuto e Regolamenti", subtitle: "Documenti ufficiali di Confcommercio Roma", path: "/chi-siamo/statuto-e-regolamenti", keywords: "statuto regolamento documenti ufficiali" },
  { title: "Trasparenza", subtitle: "Bilanci, contributi pubblici e adempimenti", path: "/chi-siamo/trasparenza", keywords: "trasparenza bilanci contributi pubblici" },
  { title: "C.A.T. Confcommercio Roma", subtitle: "Centro di Assistenza Tecnica", path: "/chi-siamo/cat", keywords: "cat centro assistenza tecnica" },
  { title: "Promo.Ter", subtitle: "Servizi e formazione per il terziario", path: "/chi-siamo/enti-collegati/promo-ter", keywords: "promoter promo.ter formazione terziario" },
  { title: "Partner", subtitle: "I partner istituzionali di Confcommercio Roma", path: "/chi-siamo/partner", keywords: "partner istituzionali collaborazioni" },
  { title: "Rappresentanza", subtitle: "I nostri servizi di rappresentanza per le aziende", path: "/chi-siamo#servizi-rappresentanza", keywords: "rappresentanza lobbying istituzioni servizi aziende" },
  { title: "Servizi", subtitle: "Tutti i servizi per le imprese associate", path: "/servizi", keywords: "servizi imprese consulenza" },
  { title: "Formazione", subtitle: "Corsi, formazione continua, apprendistato", path: "/formazione", keywords: "formazione corsi apprendistato professionale" },
  { title: "Calendario Corsi", subtitle: "Elenco corsi con date di inizio", path: "/formazione/corsi-in-partenza", keywords: "corsi partenza calendario didattica" },
  { title: "Iscrizione a un corso", subtitle: "Modulo di domanda per iscriversi ai corsi", path: "/formazione/iscrizione-corso", keywords: "iscrizione corso domanda registrazione" },
  { title: "Area Lavoro e Welfare", subtitle: "Contrattazione, welfare, sicurezza", path: "/area-lavoro-welfare", keywords: "lavoro welfare contrattazione dipendenti" },
  { title: "Convenzioni", subtitle: "Sconti e vantaggi per gli associati", path: "/convenzioni", keywords: "convenzioni sconti vantaggi partner" },
  { title: "Associazioni", subtitle: "Le 29 associazioni di categoria", path: "/associazioni", keywords: "associazioni categoria settore federazioni" },
  { title: "Ricerca e Progetti", subtitle: "Osservatori, bussole, ricerche di settore", path: "/ricerca-e-progetti", keywords: "ricerca progetti osservatori studi" },
  { title: "Osservatorio Economico", subtitle: "Analisi economiche di Roma", path: "/osservatorio-economico", keywords: "osservatorio economico dati analisi" },
  { title: "Le Bussole Confcommercio", subtitle: "Guide operative per le imprese", path: "/le-bussole", keywords: "bussole guide manuali operativi" },
  { title: "Progetti", subtitle: "Iniziative e progetti in corso", path: "/progetti", keywords: "progetti iniziative green business" },
  { title: "Notizie", subtitle: "Ultime notizie e comunicati", path: "/notizie", keywords: "notizie news comunicati stampa" },
  { title: "Eventi", subtitle: "Eventi, workshop, seminari, convegni", path: "/eventi", keywords: "eventi workshop seminari convegni" },
  // { title: "Marketplace", subtitle: "Piattaforma marketplace per associati", path: "/marketplace", keywords: "marketplace prodotti servizi vendita" }, // bozza: oscurato dalla ricerca
  { title: "Contatti", subtitle: "Come contattarci: telefono, email, sedi", path: "/contatti", keywords: "contatti telefono email sedi" },
  { title: "Lavora con noi", subtitle: "Candidature spontanee e posizioni aperte", path: "/contatti/lavora-con-noi", keywords: "lavora con noi candidatura posizioni aperte cv" },
  { title: "Diventa Socio", subtitle: "Come associarsi a Confcommercio Roma", path: "/diventa-socio", keywords: "diventa socio iscrizione associazione tessera" },
  { title: "Associati ora", subtitle: "Modulo di adesione online", path: "/associati-ora", keywords: "associati ora adesione modulo" },
  // { title: "Area Riservata", subtitle: "Portale associati riservato", path: "/area-riservata", keywords: "area riservata login portale associati" }, // bozza: oscurato dalla ricerca
];

function normalize(str) {
  return (str || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

// Costruisce l'indice completo del sito.
export function buildSearchIndex() {
  const items = [];

  // Pagine statiche
  STATIC_PAGES.forEach((p) => {
    items.push({
      group: "Pagine",
      title: p.title,
      subtitle: p.subtitle,
      path: p.path,
      _hay: normalize(`${p.title} ${p.subtitle} ${p.keywords}`),
    });
  });

  // Servizi (categorie e singoli servizi)
  SERVIZI_CATEGORIE.forEach((cat) => {
    items.push({
      group: "Servizi",
      title: cat.titolo,
      subtitle: cat.descrizione,
      path: `/servizi#${cat.id}`,
      _hay: normalize(`${cat.titolo} ${cat.descrizione}`),
    });
    (cat.servizi || []).forEach((s) => {
      items.push({
        group: "Servizi",
        title: s.nome,
        subtitle: s.desc,
        path: `/servizi#${cat.id}`,
        _hay: normalize(`${s.nome} ${s.desc}`),
      });
    });
  });

  // Corsi
  CORSI.forEach((c) => {
    items.push({
      group: "Corsi",
      title: c.titolo,
      subtitle: `${c.categoria || ""}${c.dataInizio ? " · dal " + c.dataInizio : ""}`,
      path: `/formazione/corsi-in-partenza/${c.slug}`,
      _hay: normalize(`${c.titolo} ${c.categoria || ""} ${c.finalita || ""} ${c.codice || ""}`),
    });
  });

  // Convenzioni (partner)
  Object.entries(PARTNER_DETTAGLI).forEach(([slug, p]) => {
    items.push({
      group: "Convenzioni",
      title: p.nome,
      subtitle: p.tagline || p.scontoLabel || p.categoria,
      path: `/convenzioni/${slug}`,
      _hay: normalize(`${p.nome} ${p.tagline || ""} ${p.descrizione || ""} ${p.categoria || ""} ${p.scontoLabel || ""}`),
    });
  });

  // Associazioni (elenco completo)
  ASSOC_LIST.forEach((a) => {
    items.push({
      group: "Associazioni",
      title: a.nome,
      subtitle: `${a.tipologia || ""}${a.mercato ? " · " + a.mercato : ""}`,
      path: `/associazioni/${a.id}`,
      _hay: normalize(`${a.nome} ${a.tipologia || ""} ${a.mercato || ""} ${a.descrizione || ""}`),
    });
  });

  // Fallback: alcune sigle presenti in home ma non nel dettaglio
  ASSOC_HOME.forEach((a) => {
    if (!ASSOC_LIST.find((x) => normalize(x.nome).includes(normalize(a.sigla)))) {
      items.push({
        group: "Associazioni",
        title: a.nome,
        subtitle: a.desc,
        path: "/associazioni",
        _hay: normalize(`${a.sigla} ${a.nome} ${a.desc}`),
      });
    }
  });

  // Notizie
  NEWS_FULL.forEach((n) => {
    items.push({
      group: "Notizie",
      title: n.titolo,
      subtitle: `${n.categoria || ""}${n.data ? " · " + n.data : ""}`,
      path: `/notizie/${n.slug}`,
      _hay: normalize(`${n.titolo} ${n.categoria || ""} ${n.excerpt || ""}`),
    });
  });

  // Eventi
  EVENTI_FULL.forEach((e) => {
    items.push({
      group: "Eventi",
      title: e.titolo,
      subtitle: `${e.tipo || ""}${e.data ? " · " + e.data : ""}`,
      path: `/eventi/${e.slug}`,
      _hay: normalize(`${e.titolo} ${e.tipo || ""} ${e.data || ""}`),
    });
  });

  // Impegno politico (temi)
  IMPEGNO_POLITICO_TEMI.forEach((t) => {
    items.push({
      group: "Impegno politico",
      title: t.titolo,
      subtitle: t.sottotitolo || t.descrizioneBreve,
      path: `/chi-siamo/impegno-politico/${t.slug}`,
      _hay: normalize(`${t.titolo} ${t.sottotitolo || ""} ${t.descrizioneBreve || ""}`),
    });
  });

  return items;
}

// Effettua una ricerca fuzzy semplice basata su inclusione di token.
// Ritorna al massimo `limit` risultati, ordinati per rilevanza.
export function searchIndex(index, query, limit = 20) {
  const q = normalize(query).trim();
  if (!q) return [];
  const tokens = q.split(/\s+/).filter(Boolean);

  const scored = [];
  for (const item of index) {
    let score = 0;
    let allMatch = true;
    for (const t of tokens) {
      if (item._hay.includes(t)) {
        // Bonus se match nel titolo
        const titleNorm = normalize(item.title);
        if (titleNorm.includes(t)) score += 3;
        else score += 1;
        // Bonus se il titolo inizia con il token
        if (titleNorm.startsWith(t)) score += 2;
      } else {
        allMatch = false;
        break;
      }
    }
    if (allMatch) scored.push({ ...item, _score: score });
  }
  scored.sort((a, b) => b._score - a._score);
  return scored.slice(0, limit);
}
